/** @file The 3 x 3 compass of the Directions panel: NW N NE / W - E / SW S SE with each cell's state. */
import { allowedDirs } from '@pose2d/commands/direction/allowedDirs';
import type { Dir, DirectionEntry, DirectionsDoc } from '@pose2d/format/types';

/** One compass cell; the centre has `dir: null`. A direction without an entry plays as authored (§5.8): `mode` null. */
export interface CompassCell {
  dir: Dir | null;
  allowed: boolean;
  mode: DirectionEntry['mode'] | null;
}

const GRID: readonly (Dir | null)[] = ['NW', 'N', 'NE', 'W', null, 'E', 'SW', 'S', 'SE'];

/** Nine cells in reading order; `allowed` follows the set's count and 4-layout (commands' allowedDirs). */
export function compassCells(set: DirectionsDoc): CompassCell[] {
  const allowed = allowedDirs(set.count, set.layout4);
  return GRID.map((dir) => (dir === null ? { dir, allowed: false, mode: null } : { dir, allowed: allowed.includes(dir), mode: set.entries[dir]?.mode ?? null }));
}
